export default __webpack_public_path__ + "static/media/absence.a5849e75.svg";